export enum SystemActionCategoryTypeEnum {
  'ADMIN_API' = 'API ADMIN',
  'ADMIN_WEB' = 'ADMIN WEB',
  'PDV_API' = 'PDV API',
  'PDV_WEB' = 'PDV WEB',
}

export enum SystemActionCategoryTypeIdEnum {
  'API ADMIN' = 1,
  'ADMIN WEB' = 2,
  'PDV API' = 3,
  'PDV WEB' = 4,
}

export function getSystemActionCategoryTypeDescriptionByValue(value: number) {
  const indexOfS = Object.values(SystemActionCategoryTypeIdEnum).indexOf(
    value as unknown as SystemActionCategoryTypeIdEnum
  );

  const key = Object.keys(SystemActionCategoryTypeIdEnum)[indexOfS];

  return key;
}
